import { SpecializedSingleSelectFilterProps } from "@components/job_search/filters/single_select_filter.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu.tsx";
import Button from "@sprout/button.tsx";
import CaretIcon from "@sprout/icons/caret.tsx";
import { RadioGroup, RadioGroupItem } from "@components/ui/radio-group.tsx";
import { Body } from "@sprout/typography.tsx";

export const DesktopSingleSelectFilter = ({
  buttonText,
  options,
  value,
  onValueChange,
}: SpecializedSingleSelectFilterProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="medium" className="inline-flex items-center justify-between gap-1">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <CaretIcon size="sm" color="green" />
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={0} className="pt-4 pb-6 px-6 ">
        <div className="">
          <RadioGroup value={value} onValueChange={onValueChange} className="flex flex-col gap-2">
            {options.map((option) => (
              <div key={option} className="flex items-center space-x-2 w-48">
                <RadioGroupItem value={option} id={option} />
                <label htmlFor={option} className="cursor-pointer w-full">
                  <Body secondary style={{ lineHeight: "24px" }}>
                    {option}
                  </Body>
                </label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
